import {makeStyles} from 'external/material'

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    padding: 20,
    flexDirection: 'column',
    '& .choices' : {
    }
  },
}))

export {useStyles as default}
